import React from "react";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import { useTheme } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import Alert from "@mui/material/Alert";
import Slide from "@mui/material/Slide";
import Snackbar from "@mui/material/Snackbar";
import CircularProgress from "@mui/material/CircularProgress";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import { useNavigate, useLocation } from "react-router-dom";
import { useStyles } from "../../assets/styles/Theme";
import Navbar from "../../components/common/Navbar";
import AddToolbar from "../../components/common/AddToolbar";
import {
  LOCATION_API_01,
  MAPLOCATION_API_01,
  SHOP_API_02,
  SHOP_API_03,
} from "../../api/ApiModel";
import {
  externalgetApi,
  externalpostApi,
} from "../../services/external/externalApis";
import { MenuItem } from "@mui/material";
import { Autocomplete, t } from "@mui/material";
import {
  CON_CAT_TYPE_POS,
  CON_CAT_TYPE_RESTAURANT,
  CON_STATUS_ACTIVE,
  CON_STATUS_NO,
  CON_STATUS_NONE,
} from "../../utils/sys/Constants";

function AddShop() {
  const [errors, setErrors] = useState({});
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = useStyles(theme);
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState(null);
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, GROUPCODE, USERNAME, RESTCODE, USERREFCODE } =
    SYS_USER.USER_PARAM || {};
  const [selectedLOC, setSelectedLOC] = useState("");
  const [dataloc, setDataloc] = useState([]);
  const selectedItem = location.state?.selectedItem || {};
  const [businessTypes, setBusinessTypes] = useState([]);
  console.log("selecte items", selectedItem);

  useEffect(() => {
    if (location.state && location.state.selectedItem) {
      setSelectedItemDetails(location.state.selectedItem);
    }
  }, [location.state]);

  const [selectedItemDetails, setSelectedItemDetails] = useState({
    RESTCODE: RESTCODE || "",
    RESPIN: "",
    QRCODE: "",
    COMPCODE: COMPCODE,
    LOCCODE: "",
    RESTNAME: "",
    DESCRIPTION: "",
    ADDRESS1: "",
    ADDRESS2: "",
    ADDRESS3: "",
    EMAIL: "",
    HOTLINE: "",
    FAX: "",
    BUSINESSTYPECODE: "",
    OPRDATE: new Date().toISOString().split("T")[0],
    OPSTS: "A",
    ISCHAIN: CON_STATUS_NO,
    CATTYPE: "P",
    SALESSTYLETYPE: "G",
    INVSEQNO: "",
    LOCDATE: new Date().toISOString().split("T")[0],
    ENUSER: USERNAME,
    STS: CON_STATUS_ACTIVE,
  });

  const gotToPage = () => {
    navigate("/ViewShop");
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (value.length <= 40) {
      setSelectedItemDetails((prevDetails) => ({
        ...prevDetails,
        [name]: value,
      }));

      // Remove error if the field is filled and within the limit
      if (errors[name]) {
        setErrors((prev) => ({ ...prev, [name]: undefined }));
      }
    } else {
      // Set an error if the length exceeds 40 characters
      setErrors((prev) => ({
        ...prev,
        [name]: "Value must not exceed 40 characters.",
      }));
    }
  };

  const handleBusinessTypeChange = (event) => {
    const selectedBusinessType = businessTypes.find(
      (type) => type.BUSINESSTYPECODE === event.target.value
    );

    if (selectedBusinessType) {
      setSelectedItemDetails((prevDetails) => ({
        ...prevDetails,
        BUSINESSTYPECODE: selectedBusinessType.BUSINESSTYPECODE,
        CATTYPE: selectedBusinessType.CATTYPE, // Update CATTYPE based on BUSINESSTYPECODE
      }));
    }
  };

  const handleInputEmailValidation = (event) => {
    const { name, value } = event.target;
    const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    // Update userDetails state first
    handleInputChange(event);

    // Validate the email input
    if (value.trim() === "") {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "Email is required.", // Optional: check for empty input
      }));
    } else if (validateEmail(value)) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" })); // Clear error on valid email
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "Please enter a valid email address.", // Set error message for invalid email
      }));
    }
  };
  const handleClearClick = () => {
    setSelectedItemDetails({
      RESTCODE: "",
      RESPIN: "",
      QRCODE: "",
      COMPCODE: "",
      LOCCODE: "",
      RESTNAME: "",
      DESCRIPTION: "",
      ADDRESS1: "",
      ADDRESS2: "",
      ADDRESS3: "",
      EMAIL: "",
      HOTLINE: "",
      FAX: "",
      BUSINESSTYPECODE: "",
      OPRDATE: new Date().toISOString().split("T")[0],
      OPSTS: "A",
      ISCHAIN: CON_STATUS_NO,
      CATTYPE: "P",
      SALESSTYLETYPE: "G",
      INVSEQNO: "",
      LOCDATE: new Date().toISOString().split("T")[0],
      ENUSER: USERNAME,
      STS: CON_STATUS_ACTIVE,
    });
  };

  const handleErrorSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorSnackbar(false); // Reset the snackbar state
  };

  useEffect(() => {
    fetchBusinessTypes();
  }, []);

  const fetchBusinessTypes = async () => {
    try {
      const response = await externalgetApi(SHOP_API_03, "get", {
        STS: CON_STATUS_ACTIVE,
      });
      setBusinessTypes(response);

      console.log("result business type", response);
      // setIsLoading(false);
    } catch (err) {
      console.error("Error fetching data:", err);
      // } finally {
      //   setIsLoading(false);
    }
  };

  const validateFields = () => {
    const requiredFields = [
      "LOCCODE",
      "RESTNAME",
      "DESCRIPTION",
      "ADDRESS1",
      "HOTLINE",
      "BUSINESSTYPECODE",
      "EMAIL",
      "OPRDATE",
    ];
    const newErrors = {};

    requiredFields.forEach((field) => {
      if (!selectedItemDetails[field]) {
        newErrors[field] = "This field is required.";
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleConfirmClick = async () => {
    // Step 1: Validate required fields
    if (!validateFields()) {
      setSnackbarMessage("Please fill all required fields.");
      setOpenErrorSnackbar(true);
      return;
    }
    // Step 2: Validate email format
    const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    if (!validateEmail(selectedItemDetails.EMAIL)) {
      setErrors((prevErrors) => ({}));
      setSnackbarMessage("Please enter a valid email address.");
      setOpenErrorSnackbar(true);
      return; // Stop further execution if the email is invalid
    }
    if (!validateFields()) {
      setSnackbarMessage("Please fill all required fields.");
      setOpenErrorSnackbar(true);
      return;
    }

    const payload = {
      ...selectedItemDetails,
      RESTCODE: String(selectedItemDetails.RESTCODE),
      COMPCODE: COMPCODE,
      QRCODE: CON_STATUS_NONE,
      LOCDATE:
        selectedItemDetails.LOCDATE || new Date().toISOString().split("T")[0],
      STS: CON_STATUS_ACTIVE,
      CATTYPE: selectedItemDetails.CATTYPE,
      INVSEQNO: String(selectedItemDetails.INVSEQNO),
    };

    try {
      console.log("Sending Payload:", payload);
      const response = await externalpostApi(SHOP_API_02, payload);
      console.log("API Response:", response);

      if (response && response === true) {
        setSnackbarMessage(
          selectedItemDetails.RESTCODE
            ? "Shop Updated Successfully!"
            : "Shop added successfully!"
        );
        setOpenSnackbar(true);
        setTimeout(() => navigate("/ViewShop"), 2000);
      } else {
        throw new Error(response.message || "Unexpected API response.");
      }
    } catch (error) {
      console.error("API Error:", error.response || error.message);
      setSnackbarMessage(
        error.response?.data?.message || "Error: Unable to process the request."
      );
      setOpenErrorSnackbar(true);
    }
  };

  useEffect(() => {
    const fetchLocations = async () => {
      try {
        const result = await externalgetApi(LOCATION_API_01, "get", {
          COMPCODE,
          GROUPCODE,
          USERNAME,
          STS: CON_STATUS_ACTIVE, // Fetch only items where STS is 'A'
        });

        setDataloc(result);
        console.log("Filtered Locations:", result);
      } catch (err) {
        console.error("Error fetching data:", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchLocations();
  }, []);

  const handleNumInputValidation = (event) => {
    const { name, value } = event.target;

    // Regular expression to allow only numbers and floats
    const regex = /^[0-9]*\.?[0-9]*$/;

    if (regex.test(value) && value.length <= 10) {
      // Valid input: matches regex and is within 10-character limit
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" })); // Clear error for this field
      setSelectedItemDetails((prevDetails) => ({
        ...prevDetails,
        [name]: value, // Update state with the valid input
      }));
    } else if (value.length > 10) {
      // Exceeds character limit
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "Contact cannot exceed 10 characters.",
      }));
    } else {
      // Invalid format
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "Only numbers and floats are allowed.",
      }));
    }
  };

  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs}
                position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Shops</Link>
                <Link underline="none">Add Shop</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack
                sx={{
                  ...styles.AI_fixedStack,
                  direction: "row",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  onClick={gotToPage}
                  variant="contained"
                  startIcon={<ArrowBackIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "1px",
                    width: "80px",
                  }}
                  id="btnback"
                >
                  Back
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      <Box sx={styles.AI_AddStyledBox}>
        <AddToolbar label={{ name: "Add Shop" }} />
        <Grid container spacing={2} sx={styles.AI_container}>
          <Grid item lg={6} md={6} xs={12} sm={12}>
            <Autocomplete
              options={Array.isArray(dataloc) ? dataloc : []}
              getOptionLabel={(option) => option.LOCATION || ""}
              renderInput={(params) => (
                <TextField
                  {...params}
                  // label="Location"
                  label={
                    <span>
                      Location<span style={{ color: "red" }}> *</span>
                    </span>
                  }
                  size="small"
                  variant="outlined"
                  error={Boolean(errors.LOCCODE)}
                  helperText={errors.LOCCODE}
                  disabled={!!selectedItemDetails.RESTCODE}
                />
              )}
              ListboxProps={{
                style: {
                  maxHeight: 150,
                  backgroundColor: theme.palette.background.paper,
                },
              }}
              value={
                dataloc.find(
                  (loc) => loc.LOCCODE === selectedItemDetails.LOCCODE
                ) || null
              }
              error={Boolean(errors.LOCCODE)}
              helperText={errors.LOCCODE}
              onChange={(event, newValue) => {
                setSelectedItemDetails((prevDetails) => ({
                  ...prevDetails,
                  LOCCODE: newValue ? newValue.LOCCODE : "",
                }));

                // Clear the error for LOCCODE when a value is selected
                setErrors((prevErrors) => ({
                  ...prevErrors,
                  LOCCODE: "",
                }));
              }}
            />
          </Grid>
          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              label={
                <span>
                  Hotline<span style={{ color: "red" }}> *</span>
                </span>
              }
              id="txthotline"
              size="small"
              fullWidth
              variant="outlined"
              autoComplete="off"
              name="HOTLINE"
              value={selectedItemDetails.HOTLINE}
              onChange={handleNumInputValidation}
              error={Boolean(errors.HOTLINE)}
              helperText={errors.HOTLINE}
            />
          </Grid>
          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              label={
                <span>
                  Shop Name<span style={{ color: "red" }}> *</span>
                </span>
              }
              id="txtshopname"
              size="small"
              fullWidth
              variant="outlined"
              autoComplete="off"
              name="RESTNAME"
              value={selectedItemDetails.RESTNAME}
              onChange={handleInputChange}
              error={Boolean(errors.RESTNAME)}
              helperText={errors.RESTNAME}
            />
          </Grid>
          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              label="Fax"
              id="txtfax"
              size="small"
              fullWidth
              variant="outlined"
              autoComplete="off"
              name="FAX"
              value={selectedItemDetails.FAX}
              onChange={handleNumInputValidation}
              error={Boolean(errors.FAX)}
              helperText={errors.FAX}
            />
          </Grid>
          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              label={
                <span>
                  Description <span style={{ color: "red" }}> *</span>
                </span>
              }
              id="txtdescription"
              size="small"
              fullWidth
              variant="outlined"
              autoComplete="off"
              name="DESCRIPTION"
              value={selectedItemDetails.DESCRIPTION}
              onChange={handleInputChange}
              error={Boolean(errors.DESCRIPTION)}
              helperText={errors.DESCRIPTION}
            />
          </Grid>{" "}
          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              label={
                <span>
                  Email <span style={{ color: "red" }}> *</span>
                </span>
              }
              id="txtemail"
              size="small"
              fullWidth
              variant="outlined"
              autoComplete="off"
              name="EMAIL"
              value={selectedItemDetails.EMAIL}
              onChange={handleInputEmailValidation}
              error={Boolean(errors.EMAIL)}
              helperText={errors.EMAIL}
            />
          </Grid>{" "}
          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              select
              label={
                <span>
                  Bussiness Type<span style={{ color: "red" }}> *</span>
                </span>
              }
              id="txtbsnstype"
              size="small"
              fullWidth
              variant="outlined"
              autoComplete="off"
              name="BUSINESSTYPECODE"
              value={selectedItemDetails.BUSINESSTYPECODE}
              onChange={handleBusinessTypeChange}
              error={Boolean(errors.BUSINESSTYPECODE)}
              helperText={errors.BUSINESSTYPECODE}
            >
              {businessTypes.map((businessType) => (
                <MenuItem
                  key={businessType.BUSINESSTYPECODE}
                  value={businessType.BUSINESSTYPECODE}
                >
                  {businessType.BUSINESSTYPE}
                </MenuItem>
              ))}
            </TextField>
          </Grid>{" "}
          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              select
              label="Sales Screen Type"
              id="SALESSTYLETYPE"
              size="small"
              fullWidth
              variant="outlined"
              autoComplete="off"
              name="SALESSTYLETYPE"
              //  value="Grid"
              value={selectedItemDetails.SALESSTYLETYPE || "G"}
              onChange={handleInputChange}
              error={Boolean(errors.SALESSTYLETYPE)}
              helperText={errors.SALESSTYLETYPE}
            >
              <MenuItem value="G">Grid View</MenuItem>
              <MenuItem value="L">List View</MenuItem>
            </TextField>
          </Grid>{" "}
          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              label={
                <span>
                  Address Line 1<span style={{ color: "red" }}> *</span>
                </span>
              }
              id="ADDRESS1"
              size="small"
              fullWidth
              variant="outlined"
              autoComplete="off"
              name="ADDRESS1"
              value={selectedItemDetails.ADDRESS1}
              onChange={handleInputChange}
              error={Boolean(errors.ADDRESS1)}
              helperText={errors.ADDRESS1}
            />
          </Grid>{" "}
          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              select
              label=" Is Chain"
              id="txtchain"
              size="small"
              fullWidth
              variant="outlined"
              autoComplete="off"
              name="ISCHAIN"
              value={selectedItemDetails.ISCHAIN || "Y"}
              onChange={handleInputChange}
              error={Boolean(errors.ISCHAIN)}
              helperText={errors.ISCHAIN}
            >
              <MenuItem value="Y">YES</MenuItem>
              <MenuItem value="N">NO</MenuItem>
            </TextField>
          </Grid>
          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              label="Address Line 2"
              id="ADDRESS2"
              size="small"
              fullWidth
              variant="outlined"
              autoComplete="off"
              name="ADDRESS2"
              value={selectedItemDetails.ADDRESS2}
              onChange={handleInputChange}
              error={Boolean(errors.ADDRESS2)}
              helperText={errors.ADDRESS2}
            />
          </Grid>
          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              label={
                <span>
                  Start Date<span style={{ color: "red" }}> *</span>
                </span>
              }
              id="txtstartdate"
              size="small"
              fullWidth
              variant="outlined"
              autoComplete="off"
              name="OPRDATE"
              value={selectedItemDetails.OPRDATE || ""}
              onChange={handleInputChange}
              error={Boolean(errors.OPRDATE)}
              helperText={errors.OPRDATE}
              type="date"
              InputLabelProps={{
                shrink: true, // Ensures the label shrinks when a value is present
              }}
              inputProps={{
                min: new Date().toISOString().split("T")[0], // Disable past dates
              }}
            />
          </Grid>{" "}
          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              label={<span>Address Line 3</span>}
              id="ADDRESS3"
              size="small"
              fullWidth
              variant="outlined"
              autoComplete="off"
              name="ADDRESS3"
              value={selectedItemDetails.ADDRESS3}
              onChange={handleInputChange}
              error={Boolean(errors.ADDRESS3)}
              helperText={errors.ADDRESS3}
            />
          </Grid>
        </Grid>
        <Stack
          direction="row"
          spacing={2}
          m={1}
          justifyContent="flex-end"
          padding={1}
        >
          <Button
            variant="outlined"
            sx={styles.AI_button1}
            onClick={handleClearClick}
            id="btnclr"
          >
            Clear
          </Button>
          <Button
            variant="contained"
            sx={styles.AI_button2}
            onClick={handleConfirmClick}
            id="btnconfirm"
          >
            Confirm
          </Button>
        </Stack>

        <Snackbar
          open={openSnackbar}
          autoHideDuration={4000}
          onClose={() => setOpenSnackbar(false)}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          TransitionComponent={(props) => <Slide {...props} direction="left" />} // Slide in from the right
          sx={{ top: "10%", right: "10%" }}
        >
          <Alert
            onClose={() => setOpenSnackbar(false)}
            severity="success"
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>

        <Snackbar
          open={openErrorSnackbar}
          autoHideDuration={6000}
          onClose={handleErrorSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          TransitionComponent={(props) => <Slide {...props} direction="left" />} // Slide in from the right
          sx={{ top: "10%", right: "10%" }}
        >
          <Alert
            onClose={handleErrorSnackbarClose}
            severity="error"
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Box>
    </div>
  );
}

export default AddShop;
